import { createConfirmation } from "react-confirm";
import AddUnitDialog from "./AddUnitDialog";

export const showAddUnitDialog = createConfirmation(AddUnitDialog);
